export default "__VITE_ASSET__06f3ca69__"